import { useState, useEffect, useContext } from "react";
import Indent from "./Indent";
import { Activity, currentRequestTimeStamp } from "../../Constants";
import Loader from "../Loader";
import ReactGA from "react-ga4";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import { useIndentTracking } from "./hooks/useIndentTracking";

const IndentRequestMain = (props) => {
  const [show, setshow] = useState(false);

  const [policy, setpolicy] = useState(false);
  const [details, setdetails] = useState([]);
  const [filtered_details, setfiltered_details] = useState([]);
  const { userDetails } = useContext(UserApiContext);

  const { trackIndentEvent } = useIndentTracking();

  useEffect(() => {
    document.title = "LoRRI Indent - Indent Requests";
    ReactGA.send("LoRRI Indent - Indent Requests");
    Activity([
      {
        screen: "Indents",
        module: "Indents Request",
        user_activity: "Indent Request page visited",
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
      },
    ]);
    trackIndentEvent(
      "indent request",
      "user has visited indent request screen"
    );
    setpolicy(userDetails?.policy);
  }, [userDetails]);

  return (
    <div>
      <Loader show={show} />
      <div id="indents" style={{ width: "100%" }}>
        <Indent
          show={show}
          setshow={setshow}
          details={details}
          policy={policy}
          setdetails={setdetails}
          filtered_details={filtered_details}
          setfiltered_details={setfiltered_details}
        />
      </div>
    </div>
  );
};

export default IndentRequestMain;
